export enum FileStoragePathEnum {
    CERTIFICATE = 'certificate',
    EXAMPLE_DOCUMENTS = 'exampleDocuments',
}
